// extracted by mini-css-extract-plugin
module.exports = {"container":"e_vr","poster":"e_wr","player":"e_xr","play":"e_yr","playBadge":"e_zr","playIcon":"e_Ar","loading":"e_Br","spin":"e_Cr"};